// 本地开发默认走本机后端服务
let commonUrl = "";


let baseUrl = {
    commonUrl
}

export default baseUrl
